import styled from 'styled-components';
import { MQUERY } from 'common/constants';
import { multiLineClamp } from 'styles/mixins/text';
import VideoPlayCta from 'common/components/videos/video-play-cta';
import Button from 'common/components/button';

export const ImageContainer = styled.div`
    position: relative;
    padding-bottom: calc(56.5% - 1px);
    border-radius: 12px;
    box-shadow: 0 15px 20px rgba(0, 0, 0, 0.4);
    overflow: hidden;
    transition: opacity .5s ease-in-out;

    @media ${ MQUERY.DESKTOP_SMALL } {
        height: 60rem;
        padding-bottom: 0;

        &::after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: linear-gradient(197deg, rgba(22, 26, 39, 0) 15%, var(--imageBackground) 90%);
            transition: opacity .5s ease-in-out;
            z-index: 10;
        }
    }
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    padding-top: 2.4rem;

    @media ${ MQUERY.DESKTOP_SMALL } {
        display: block;
        position: absolute;
        bottom: 0;
        padding: 2.4rem;
        z-index: 10;

        button {
            width: initial;
        }
    }
`;

export const SeriesTitle = styled.h2`
    color: var(--text);
    margin-top: 0;
    font-size: var(--header3);
    line-height: 1.2;

    @media ${ MQUERY.DESKTOP_SMALL } {
        color: var(--lightText);
        margin-top: 1.6rem;
        margin-bottom: 1.4rem;
        font-size: var(--header2);
        transition: opacity .5s ease-in-out .5s;
    }
`;

export const ChannelName = styled.h3`
    color: var(--text);
    margin-top: 0.8rem;
    font-size: var(--header4);
    line-height: 1.2;

    @media ${ MQUERY.DESKTOP_SMALL } {
        color: var(--lightText);
        font-size: var(--header3);
        transition: opacity .5s ease-in-out .5s;
    }
`;

export const Description = styled.p`
    ${ multiLineClamp( { lines: 4 } ) }
    color: var(--text);
    line-height: 1.5;
    font-weight: var(--light);
    margin-top: 0;

    @media ${ MQUERY.DESKTOP_SMALL } {
        color: var(--lightText);
        max-width: 64.4rem;
        -webkit-line-clamp: 5;
        transition: opacity .5s ease-in-out .5s;
    }
`;

export const PlayCta = styled( VideoPlayCta )`
    margin: 1.6rem 0;

    @media ${ MQUERY.DESKTOP_SMALL } {
        margin: 2.4rem 0;
    }
`;

export const CtaButton = styled( Button )`
    margin-top: 2.4rem;
    order: 1;
    width: 100%;

    @media ${ MQUERY.DESKTOP_SMALL } {
        display: inline-block;
        transition: opacity .5s ease-in-out .5s;
        width: initial;
    }
`;

export const VideoPromo = styled.div`
    position: relative;
    display: block;
    margin: 3rem 0 6.2rem;
    padding: 0 1.2rem;

    &:hover {
        text-decoration: none;
    }

    @media ${ MQUERY.DESKTOP_SMALL } {
        max-width: var(--widget-width);
        margin: 6.4rem auto 6.2rem;
        transition: transform 0.25s ease;

        &:hover,
        &:focus {
            transform: scale(1.03);
        }

        &.is-active {
            ${CtaButton},
            ${Description},
            ${ChannelName},
            ${SeriesTitle},
            ${ImageContainer} {
                opacity: 0;
                transition: opacity .5s ease-in-out;
            }

            ${ImageContainer} {
                &::after {
                    opacity: 0;
                }
            }

            .video-js.vjs-playing {
                &::after {
                    opacity: 0;
                    pointer-events: none;
                }
            }
        }
    }
`;